import { useEffect, useState } from "react";

import { api, type SiteConfig } from "@/lib/api";

/** Deployment facts (network, treasury, launches on/off). Null until loaded. */
export function useConfig(): SiteConfig | null {
  const [config, setConfig] = useState<SiteConfig | null>(null);
  useEffect(() => {
    api.config().then(setConfig).catch(() => undefined);
  }, []);
  return config;
}
